import { Component, h } from 'preact';

import capitalize from '../utils/capitalize';

const StreamTab = ({
  chamber,
  info,
  isLive,
  onClick,
  isActive,
  includeInfo = true
}) => {
  const classValue = `stream-controls__tab${isActive ? ' stream-controls__tab--active' : ''}`;
  return (
    <div
      onClick={() => onClick(chamber)}
      class={classValue}
      data-chamber={chamber}
      data-camera-id="3"
      ga-on="click"
      ga-event-category="Video"
      ga-event-action="toggle"
      ga-event-label={chamber}
    >
      <h3 class="stream-controls__label">{capitalize(chamber)}</h3>
      {includeInfo && <p class="stream-controls__info">{capitalize(info)}</p>}
      <div class="stream-controls__buttons">
        {isLive ? <span class="stream__live-label">Live</span> : null}
      </div>
    </div>
  );
};

export default StreamTab;



// WEBPACK FOOTER //
// ./components/stream-tab.js